<template>
    <div class="text-page">
        <h1>Impressum</h1>
        <p>Angaben gemäß § 5 TMG</p>
        <p>
            Roman Hock <br>
            Dahlweg 105<br>
            48156 Muenster<br>
        </p>
        <p>
            <strong>Vertreten durch:</strong><br>
            Roman Hock<br>
        </p>
        <p>
            <strong>Kontakt:</strong><br>
            E-Mail: <a href='mailto:hock@stuhrblick.de'>hock@stuhrblick.de</a></br>
        </p>
        <p>
            <strong>Haftungsausschluss: </strong><br><br>
            <strong>Haftung für Links</strong><br><br>
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
        </p>
    </div>
</template>

<script>
    export default {
        name: 'Imprint'
    }
</script>
